import usaMap from "@svg-maps/usa";

const viewBoxes: Record<string, string> = {
  AK: "123 477 426 282", AL: "903 366 80 121", AR: "785 340 100 91",
  AZ: "406 300 133 151", CA: "286 149 152 253", CO: "528 228 141 112",
  CT: "1130 167 41 40", DE: "1104 230 29 41", FL: "922 449 174 150",
  GA: "950 360 108 110", HI: "575 580 48 85", IA: "750 186 118 80",
  ID: "414 28 117 183", IL: "837 204 81 134", IN: "899 215 66 104",
  KS: "653 262 142 81", KY: "876 273 142 77", LA: "797 419 114 99",
  MA: "1129 145 72 44", MD: "1042 233 92 49", ME: "1149 37 76 113",
  MI: "847 78 145 151", MN: "742 56 126 142", MO: "764 250 129 112",
  MS: "844 371 74 120", MT: "459 32 192 127", NC: "974 302 168 79",
  ND: "635 59 127 84", NE: "625 193 157 83", NH: "1139 94 39 72",
  NJ: "1109 194 34 64", NM: "510 316 136 138", NV: "349 169 124 184",
  NY: "1027 99 144 122", OH: "947 200 85 94", OK: "635 327 164 90",
  OR: "298 60 154 131", PA: "1016 182 114 77", RI: "1157 166 23 27",
  SC: "992 351 101 79", SD: "629 128 135 93", TN: "865 321 162 63",
  TX: "557 339 261 254", UT: "441 191 111 135", VA: "981 248 152 88",
  VT: "1116 102 40 66", WA: "330 5 130 100", WI: "809 105 106 113",
  WV: "993 229 91 89", WY: "508 134 136 113",
};

const pathMap = new Map<string, string>();
for (const loc of usaMap.locations) {
  pathMap.set(loc.id.toUpperCase(), loc.path);
}

interface StateIconProps {
  abbr: string;
  className?: string;
}

export default function StateIcon({ abbr, className = "w-7 h-7" }: StateIconProps) {
  const path = pathMap.get(abbr);
  const vb = viewBoxes[abbr];

  if (!path || !vb) return null;

  return (
    <svg
      viewBox={vb}
      className={className}
      fill="currentColor"
      aria-hidden="true"
    >
      <path d={path} />
    </svg>
  );
}
